import SclaViewAppCell from './SclaViewAppCell';

export default SclaViewAppCell;
